export default {
    // 问题反馈&解答
    "selectProductTypeList" : "/backstageApi/background/answer/selectProductTypeList",
    "selectProductModelList" : "/backstageApi/background/answer/selectProductModelList",
    "selectFeedbackList" : "/backstageApi/background/answer/selectFeedbackList",
    "selectAnswerListByFeedbackId" : "/backstageApi/background/answer/selectAnswerListByFeedbackId",
    "selectFeedbackOne" : "/backstageApi/background/answer/selectFeedbackOne",
    "saveFeedback" : "/backstageApi/background/answer/saveFeedback",
    "saveAnswer" : "/backstageApi/background/answer/saveAnswer",
    "updateFeedbackState" : "/backstageApi/background/answer/updateFeedbackState",
  
  }


// WEBPACK FOOTER //
// ./src/api/answer.js